import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";
import {
  CardTraderConditionValueType,
  CardTraderLanguageValueType,
} from "magic-shared-types";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCardFromMachine: builder.query<
      {
        id: number;
        blue_print_id: number;
        language: CardTraderLanguageValueType;
        condition: CardTraderConditionValueType;
        is_foil: boolean;
      }[],
      void
    >({
      query: () => ({
        url: `${BASE_SERVER_PATH}/api/uploading-card-from-machine/get-by-user`,
        method: "GET",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const {
  useGetAllCardFromMachineQuery,
  useLazyGetAllCardFromMachineQuery,
} = myServerApis;
